document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

$(document).ready(function() {
	'use strict';


	$('[data-confirm]').click(function (event) {
		if (confirm($(this).data('confirm'))) {
			return true;
		}

		event.preventDefault();

		return false;
	});

	$('#menu-control').click(function() {
		$('#menu').toggleClass('active');

		return false;
	});

	$('#menu a').click(function() {
		$(this).parents('#menu').removeClass('active');
	});

	// Required fields dialog
	const $dialog = $('#customerProfileIncompleteDialog');
	if ($dialog.length) {
		$dialog[0].showModal();
	}
});
